import { Currency } from '@/core/currency/interfaces';

const INR: Currency = {
    name: 'Indian Rupee',
    demonym: 'Indian',
    majorSingle: 'Rupee',
    majorPlural: 'Rupees',
    codeNumeric: '356',
    symbol: 'Rs.',
    symbolNative: '₹',
    minorSingle: 'Paisa',
    minorPlural: 'Paise',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'INR',
    delimiters: {
        thousands: ',',
        decimal: '.'
    }
};

export default INR;
